const financeCreatedTemplate = `
<div class="ui-notification">
  <h3>New Finance Referral</h3>
  <div class="message">
    <a class="btn btn-primary" ui-sref="financeEdit({financeId: {{financeId}}})">View Finance</a>
  </div>
</div>
`;

export default financeCreatedTemplate;


// WEBPACK FOOTER //
// ./client/app/common/templates/notification/financeCreatedTemplate.js